import { useEffect, useState } from "react";
import { Box, CircularProgress, DialogTitle } from "@mui/material";
import { toast } from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { BASE_URL } from "../../../components/BaseUrl";
import {
  setInviteProfileUpdateToken,
  setInviteEmail,
  setProfileUpdateToken,
} from "../../../Redux/Slices/AuthSlice";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import warning from "../../../assets/warning.svg";
import { useTheme } from "@mui/material/styles";
import CustomEmailInput from "../../../components/EmailInput";
import { useTranslation } from 'react-i18next';
import { showToast } from "../../../Utlis/messageHandler";
const VerifyInvite = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const token = searchParams.get("token");
  const from = searchParams.get("from");
  const { t } = useTranslation();

  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [resendLoading, setResendLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ✅ Verify Invite API
  useEffect(() => {
    const verifyInvite = async () => {
      if (!userId || !token) {
        setErrorMessage("Invalid or missing verification link.");
        setLoading(false);
        return;
      }

      try {
        const url = `${BASE_URL}/public/account-executives/verify-invite?userId=${userId}&otp=${token}`;
        const response = await fetch(url, { method: "GET" });
        const data = await response.json();

        console.log("🔍 Raw Response Status:", response.status);
        console.log("🔍 Full Response JSON:", data);

        if (!response.ok || data.error || data.message?.toLowerCase().includes("invalid")) {
    setErrorMessage(data.message || t("alerts.inviteVerificationFailed"));
    return;
  }
        // ✅ success case
        const profileToken = data.data?.profileUpdateToken;
        if (profileToken) {
          dispatch(setInviteProfileUpdateToken(profileToken));
          dispatch(setProfileUpdateToken(profileToken));
          localStorage.setItem("inviteProfileUpdateToken", profileToken);
          localStorage.setItem("profileUpdateToken", profileToken);
        }

        if (data.data?.email) {
          dispatch(setInviteEmail(data.data.email));
          localStorage.setItem("inviteEmail", data.data.email);
        }

  showToast(toast.success, data, t("alerts.inviteVerifiedSuccess"));

        setTimeout(() => {
          if (from === "login") {
            navigate("/create-profile");
          } else {
            navigate("/set-password");
          }
        }, 1000);
      } catch (err) {
        console.error("🚨 Caught in catch block:", err.message);
  setErrorMessage(err.message || t("alerts.inviteVerificationError"));
      } finally {
        setLoading(false);
      }
    };

    verifyInvite();
  }, [userId, token, dispatch, navigate, from]);

  // 🔁 Resend Invite API
  const handleResendInvite = async () => {
    const savedEmail = email || localStorage.getItem("inviteEmail");
    const profileToken = localStorage.getItem("inviteProfileUpdateToken");
  if (!savedEmail || !profileToken) {
    showToast(toast.error, { 
      message_en: t("alerts.missingEmailOrToken"), 
      message_es: t("alerts.missingEmailOrToken") 
    });
    return;
  }

    try {
      setResendLoading(true);
      const response = await fetch(
        `${BASE_URL}/public/account-executives/resend-verification`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${profileToken}`,
          },
          body: JSON.stringify({ email: savedEmail }),
        }
      );

      const data = await response.json();
      console.log("🔄 Resend Response:", data);

       if (!response.ok || data.error) {
      showToast(toast.error, data, t("alerts.resendFailed"));
      return;
    }

    showToast(toast.success, data, t("alerts.verificationEmailResent"));
    } catch (err) {
      console.error("🚨 Resend error:", err.message);
    showToast(toast.error, err, t("alerts.resendFailed"));
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#EFF4F8",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      {loading ? (
        <CircularProgress size={40} />
      ) : errorMessage ? (
        <Box
          sx={{
            maxWidth: 420,
            width: "100%",
            bgcolor: "white",
            borderRadius: "12px",
            boxShadow: 0,
            p: 3,
            textAlign: "center",
          }}
        >
          <DialogTitle sx={{ textAlign: "center" }}>
            <img src={warning} style={{ width: 70, height: 70 }} alt="warning" />
          </DialogTitle>

          <CustomText
            sx={{
              ...textStyles.body4,
              color: theme.palette.text.primary,
              mb: 2,
            }}
          >
            {/* {errorMessage} */}
            {t("alerts.invalidVerificationToken")}
          </CustomText>

          {/* ✅ Styled email input */}
          <label
            style={{
              display: "block",
              textAlign: "left",
              marginBottom: 6,
              fontSize: 14,
              fontWeight: 500,
              color: theme.palette.text.primary,
            }}
          >
              {t("invite.emailLabel")}
          </label>
          <CustomEmailInput
            name="email"
            placeholder="john@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <CustomButton
            onClick={handleResendInvite}
            disabled={resendLoading}
            sx={{ mt: 2 }}
            label={
              resendLoading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                 {t("invite.resending")}
                </Box>
              ) : (
                  t("invite.resendButton")
              )
            }
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default VerifyInvite;


